export const XRPL_RPC_URL = 'https://xrplcluster.com/';
export const XRPL_RPC_HOST = 'xrplcluster.com';

const REQUEST_TIMEOUT_MS = 8000;

async function postJsonRpc(method, params, { timeoutMs = REQUEST_TIMEOUT_MS } = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(XRPL_RPC_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ method, params }),
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`RPC request failed with HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw new Error('XRPL RPC request timed out.');
    }
    throw error;
  } finally {
    clearTimeout(timeout);
  }
}

export async function fetchAccountInfo(address, options) {
  const payload = await postJsonRpc(
    'account_info',
    [{ account: address, ledger_index: 'validated' }],
    options
  );
  const result = payload?.result;

  if (!result) {
    throw new Error('XRPL RPC response missing result payload.');
  }

  if (result.status === 'success' && result.account_data) {
    return {
      active: true,
      balanceDrops: BigInt(result.account_data.Balance),
      ledgerIndex: result.ledger_index ?? null,
    };
  }

  if (result.error === 'actNotFound') {
    return {
      active: false,
      balanceDrops: null,
      ledgerIndex: result.ledger_index ?? null,
    };
  }

  throw new Error(result.error_message || result.error || 'XRPL RPC error');
}

export async function probeLedgerIndex(options) {
  const payload = await postJsonRpc('server_info', [{}], options);
  const info = payload?.result?.info;
  const ledgerIndex = info?.validated_ledger?.seq ?? null;

  return {
    ledgerIndex,
    serverState: info?.server_state ?? null,
  };
}
